// extracted by mini-css-extract-plugin
export default {"overflow":"ColumnFilter_overflow__ELOb3","forboredr":"ColumnFilter_forboredr__QwbRo","fontcolor":"ColumnFilter_fontcolor__nmHHN"};